/**
 * Functions
 */
const major = n => n * 8;
const minor = n => n * 4;
export default {
  major,
  minor,
};
